import React from "react";
import { motion } from "framer-motion";
import { MagneticButton, scrollToId } from "../shared";
import { HERO_BADGE, HERO_HEADLINE, HERO_SUB, HERO_STATS } from "./heroContent";

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

const HeroSection = () => (
  <section className="relative min-h-[70vh] flex items-center hero-mesh overflow-hidden pt-24 pb-8" data-testid="partner-hero">
    <div className="max-w-4xl mx-auto px-6 lg:px-8 py-24 lg:py-32 text-center">
      <motion.div
        className="inline-flex items-center space-x-3 bg-[#11151F] border border-[#00D2FF]/25 rounded-full px-4 py-2 mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.05, duration: 0.6 }}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[#00D2FF] pulse-subtle" />
        <span className="badge-mono text-partner-accent">{HERO_BADGE}</span>
      </motion.div>

      <motion.h1
        className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-[0.95] tracking-tight"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.8 }}
      >
        {HERO_HEADLINE.split("MRR").map((part, i) =>
          i === 0 ? (
            <span key={i}>
              {part}
              <span className="gradient-text">MRR</span>
            </span>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
      </motion.h1>

      <motion.p
        className="text-base sm:text-lg md:text-xl text-partner-muted max-w-2xl mx-auto font-body leading-relaxed mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.6 }}
      >
        {HERO_SUB}
      </motion.p>

      <motion.div
        className="grid grid-cols-3 gap-3 sm:gap-4 max-w-2xl mx-auto mb-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        {HERO_STATS.map((stat) => (
          <div
            key={stat.label}
            className="bento-card py-4 px-3 sm:px-5 border border-[#00D2FF]/25 bg-[#00D2FF]/5"
          >
            <div className="text-2xl sm:text-3xl font-bold font-mono text-partner-accent">{stat.value}</div>
            <div className="text-[10px] sm:text-xs font-mono text-partner-muted uppercase tracking-wide mt-1">
              {stat.label}
            </div>
          </div>
        ))}
      </motion.div>

      <motion.div
        className="flex flex-col sm:flex-row gap-3 justify-center items-stretch sm:items-center max-w-lg mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        <MagneticButton
          className="px-6 py-3.5 rounded-2xl font-semibold text-base flex items-center justify-center space-x-2"
          onClick={() => scrollToId("roi-calculator")}
        >
          <span>Calculate Your Margin</span>
          <ArrowRight />
        </MagneticButton>
        <MagneticButton
          primary={false}
          className="px-6 py-3.5 rounded-2xl font-semibold text-base"
          onClick={() => scrollToId("sandbox")}
        >
          Test Live Sandbox
        </MagneticButton>
      </motion.div>
    </div>
  </section>
);

export default HeroSection;
